// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"88":"component---src-pages-services-js","501":"component---src-pages-contact-js","624":"component---src-pages-work-js","678":"component---src-pages-index-js"}[chunkId] + "-" + {"88":"f01c1a73fe1887702bfc","501":"8f89783db862d17586c2","624":"780c74d56dbf0606a704","678":"71b86332d74514567be4"}[chunkId] + ".js";
};